import { useState } from 'react';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Links } from '../constants';
import { FacebookIcon, InstagramIcon, LinkedinIcon } from '../images/footerIcons';

const SOCIAL_LINKS = [
  { key: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/company/tempmee', Icon: LinkedinIcon },
  { key: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/tempmeeapp', Icon: FacebookIcon },
  { key: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/tempmee/', Icon: InstagramIcon },
] as const;

const NAV_LINKS = [
  { label: 'Dental Offices', href: Links.temporaryStaffing },
  { label: 'How it works', href: Links.home },
  { label: 'FAQs', href: Links.dentistsSideFaqs, noUppercase: true },
  { label: 'About', href: Links.about },
  { label: 'Terms of Service', href: Links.termsOfUse },
  { label: 'Privacy Policy', href: Links.privacyPolicy },
] as const;

type TSocialKey = (typeof SOCIAL_LINKS)[number]['key'];

export const Footer = () => {
  const [hoverIcon, setHoverIcon] = useState<TSocialKey | ''>('');
  const [hoverNav, setHoverNav] = useState('');

  return (
    <footer style={{ width: '100%', backgroundColor: colors.info.contrast, padding: '0 50px' }}>
    <Row
      align="center"
      style={{
        height: 116,
      }}
    >
        <Row align="center" style={{ gap: 35, flexWrap: 'wrap' }}>
          {NAV_LINKS.map((link) => (
            <a
            key={link.href}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            onMouseOver={() => setHoverNav(link.href)}
            onFocus={() => setHoverNav(link.href)}
            onMouseOut={() => setHoverNav('')}
            onBlur={() => setHoverNav('')}
            style={{
              textDecoration: 'none',
              textTransform: 'noUppercase' in link && link.noUppercase ? 'none' : 'uppercase',
            }}
          >
              <Typography
              as="span"
              size="body_small"
              color={hoverNav === link.href ? colors.success[400] : colors.shades[0]}
            >
                {link.label}
              </Typography>
            </a>
        ))}
        </Row>

        <div style={{ flex: 1 }} />

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Row align="center" style={{ gap: 24 }}>
            {SOCIAL_LINKS.map(({ key, label, href, Icon }) => (
              <a
              key={key}
              href={href}
              aria-label={label}
              target="_blank"
              rel="noopener noreferrer"
              onMouseOver={() => setHoverIcon(key)}
              onFocus={() => setHoverIcon(key)}
              onMouseOut={() => setHoverIcon('')}
              onBlur={() => setHoverIcon('')}
            >
                <Icon fill={hoverIcon === key ? colors.success[400] : colors.shades[0]} />
              </a>
          ))}
          </Row>
          <Typography
          as="span"
          size="body_small"
          color={colors.shades[0]}
          bold
          style={{ marginTop: 10, textAlign: 'center' }}
        >
            ©{new Date().getFullYear()} GoTu, Inc. - All Right Reserved
          </Typography>
        </div>
      </Row>
    </footer>
  );
};
